/**
 * Static sample text each variable type reads out during previews.
 *
 * Variables hold runtime data (dates, amounts, mobile numbers…), so
 * there's no design-time audio — previews synthesize one of these
 * samples instead. Keys are lowercase `variableType` values.
 * ⚠️ Verify against the variable-type options in StepTtsRows — a key
 * miss here is exactly what makes every type read the same fallback.
 */
const SAMPLES: Record<string, string> = {
  date: '12 March 2025',
  time: '11 30 AM',
  number: '1 2 3 4 5',
  currency: 'Rupees one thousand five hundred',
  text: 'text sample',
};

/** Type-aware sample text — never a fixed string across types. */
export function variableSampleText(variableType?: string): string {
  const key = (variableType ?? '').trim().toLowerCase();
  if (!key) return 'This is a sample variable';
  return SAMPLES[key] ?? `${key} sample`;
}
